import { IResponse, consumer } from "@bemap/utils"

// Types for course certificates
export interface CourseCertificate {
  id: number;
  userId: number;
  courseId: number;
  issueDate: string;
  expirationDate: string;
  status: 'waiting' | 'generated' | 'cancelled';
  hash: string;
  key?: string;
  grade?: number;
  completionPercentage: number;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: number;
    name: string;
    email: string;
  };
  course?: {
    id: number;
    title: string;
    instructor: string;
  };
}

// API calls for students
export const getMyCertificates = async (): Promise<IResponse> => {
  const url = '/course-certificates';

  try {
    return await consumer('GET', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const getCertificateById = async (id: number): Promise<IResponse> => {
  const url = `/course-certificates/${id}`;

  try {
    return await consumer('GET', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const requestCertificate = async (courseId: number): Promise<IResponse> => {
  const url = `/course-certificates/request/${courseId}`;

  try {
    return await consumer('POST', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const downloadCertificate = async (id: number): Promise<IResponse> => {
  const url = `/course-certificates/${id}/download`;
  return await consumer('GET', url);
};

export const checkCourseCompletion = async (courseId: number): Promise<IResponse> => {
  const url = `/course-certificates/check-completion/${courseId}`;

  try {
    return await consumer('POST', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
}; 